<template>
    <v-row>
        <v-col>
            <v-card class="pa-4">
                <v-card-title>{{ site.title }}</v-card-title>
                <v-card-text>
                    <SiteTabLinks />
                    <v-form class="py-6">
                        <div class="elevation-1 pa-4 my-4">
                            <v-row>
                                <v-col>
                                    <v-select
                                        v-model="setting.iiko.type"
                                        label="Тип"
                                        :items="iikoTypes"
                                        item-text="title"
                                        item-value="code"
                                        outlined
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        v-model="setting.iiko.base_url"
                                        outlined
                                        label="Url"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        v-model="setting.iiko.login"
                                        outlined
                                        label="Логин для доступа к API"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                        </div>
                        <div class="elevation-1 pa-4 my-4">
                            <v-row>
                                <v-col>
                                    <v-select
                                        v-model="setting.iiko.organizationId"
                                        label="Организации"
                                        :items="organizations"
                                        item-text="name"
                                        item-value="id"
                                        placeholder="Выберите организацию"
                                        outlined
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-select
                                        v-model="setting.iiko.externalMenuId"
                                        label="Меню"
                                        :items="menus"
                                        item-text="name"
                                        item-value="id"
                                        placeholder="Выберите меню"
                                        outlined
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                        </div>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pa-4 d-flex justify-space-between">
                    <div>
                        <v-btn
                            color="primary"
                            class="mr-3"
                            @click="save"
                        >Сохранить</v-btn>
                        <v-btn
                            color="light"
                            class="mr-3"
                            @click="goBack"
                        >Отмена</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import store from '../../store';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { mapState } from 'vuex';
    import SiteTabLinks from '../../components/sites/SiteTabLinks';

    import { imageSrc } from '../../helpers';

    export default {
        name: 'EntitySetting',

        components: {
            SiteTabLinks,
        },

        data() {
            return {
                imageSrc,
                setting: {
                    iiko: {}
                },
                iikoTypes: [
                    { code: 'web', title: 'Iiko web' }
                ]
            };
        },

        computed: {
            ...mapState('auth', ['user']),
            ...mapState('sites', {
                site: state => state.entity
            }),
            ...mapState('siteIiko', {
                organizations: state => state.organizations,
                menus: state => state.menus,
            }),
            ...mapState('siteSetting', {
                oldSetting: state => state.entity
            }),
            isAdmin() {
                return this.user.admin;
            },
        },

        async mounted() {
            const { id } = this.$route.params;
            if(id) {
                await store.dispatch('sites/get', { id });
                await store.dispatch('siteSetting/get', { site_id: id });
                this.setting = this.oldSetting;
                if(!this.setting.iiko) {
                    this.setting.iiko = {};
                } else {
                    await store.dispatch('siteIiko/organizations', { id });
                    await store.dispatch('siteIiko/menus', { id });
                }

                if(this.setting.iiko.organizationId && this.setting.iiko.externalMenuId) {
                    await store.dispatch('siteIiko/nomenclature', { id });
                }
            }
        },

        methods: {
            async save() {
                const { id } = this.$route.params;
                try {
                    store.commit('siteSetting/SET_ENTITY', this.setting);
                    await store.dispatch('siteSetting/save', { site_id: id });
                    this.goBack();
                } catch (error) {
                    alert('Ошибка сохранения');
                }
            },
            goBack() {
                const { id } = this.$route.params;
                if(id) {
                    this.$router.push(`/sites/${id}/detail`);
                } else {
                    this.$router.push('/sites');
                }
            },
        },
    };
</script>
